export default __webpack_public_path__ + "static/media/12-pulse-wave.7ebaecd4.jpg";